import type {
  CartItem,
  CartItemAccommodation,
  CartItemBeachChair,
  CartItemExperience,
  CartItemRentable,
} from '../cart'

function getTrackObjectAccommodation(item: CartItemAccommodation) {
  return {
    item_id: `A-${item.accommodation.id}`,
    item_name: item.accommodation.name,
    price: item.totalAfterDiscount ?? item.total,
    item_brand: item.accommodation.merchant.tradeName ?? '',
    item_category: 'accommodation',
    item_category2: item.roomTitle,
    item_category3: item.rateTitle,
    item_category5: item.accommodation.zipCode,
    quantity: 1,
    currency: item.currency,
    promotion_code: item.promotionCode.name,
  }
}

function getTrackObjectExperience(item: CartItemExperience) {
  return {
    item_id: `E-${item.experience.publicId}`,
    item_name: item.experience.title,
    price: item.totalAfterDiscount ?? item.total,
    item_brand: item.experience.merchant?.tradeName ?? '',
    item_category: 'experience',
    item_category2: item.experience.activities?.join(',') ?? '',
    item_category5: `${item.experience.location.lat}, ${item.experience.location.lng}`,
    quantity: 1,
    currency: item.currency,
    promotion_code: item.promotionCode.name,
  }
}

function getTrackObjectBeachChair(item: CartItemBeachChair) {
  return {
    item_id: `S-${item.beachSectionId}`,
    item_name: `${item.beachLocation?.city ?? ''} - ${item.beachChair.sectionName}`,
    price: item.totalAfterDiscount ?? item.total,
    item_category: 'beach_chair',
    item_category2: item.beachChair.sectionName,
    item_category5: item.beachLocation?.coordinate?.coordinates?.join(',') ?? '',
    quantity: 1,
    currency: item.currency,
    promotion_code: item.promotionCode.name,
  }
}

function getTrackObjectRentable(item: CartItemRentable) {
  return {
    item_id: `R-${item.id}`,
    item_name: item.shopName,
    price: item.totalAfterDiscount ?? item.total,
    currency: item.currency,
    item_category: 'bike',
    quantity: 1,
    promotion_code: item.promotionCode.name,
  }
}

export function getCartTrackObjectItems(items: CartItem[]) {
  return items.map(item => {
    switch (item.__typename) {
      case 'CartItemAccommodation':
        return getTrackObjectAccommodation(item)
      case 'CartItemExperience':
        return getTrackObjectExperience(item)
      case 'CartItemBeachChair':
        return getTrackObjectBeachChair(item)
      case 'CartItemRentable':
        return getTrackObjectRentable(item)
    }
  })
}
